import(/* webpackMode: "eager" */ "/Users/apple/Desktop/comverse/comverse-baseapp-next/app/(alfamall)/b2b-payments/page.jsx");
